import {ErrorBoundary} from "@sentry/react";

import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {DownAlert} from "@/pages/alerting/components/details/DownAlert.tsx";

interface DownAlertsListProps {
  gas: GlobalAlertState;
  onAlertDataRequest?: (id: number) => Promise<void>;
}

export const DownAlertsList = ({gas, onAlertDataRequest}: DownAlertsListProps) => (
  <ErrorBoundary>
    <div className="d-flex flex-column gap-4">
      {gas?.down_alerts.map((alert) => (
        <DownAlert key={alert.id} alert={alert} onAlertDataRequest={onAlertDataRequest} />
      ))}
    </div>
  </ErrorBoundary>
);
